<template>
  <div class="host-ad">
    <template>
      <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false" no-data-text="暂无数据">
        <template slot-scope="{ row, index }" slot="name">{{row.name}}</template>
        <template slot-scope="{ row, index }" slot="nameUrl">{{row.nameUrl}}</template>
        <template slot-scope="{ row, index }" slot="nameEn">{{row.nameEn}}</template>
        <template slot-scope="{ row, index }" slot="nameEnUrl">{{row.nameEnUrl}}</template>
        <template slot-scope="{ row, index }" slot="remark">{{row.remark}}</template>
        <template slot-scope="{ row, index }" slot="remarkEn">{{row.remarkEn}}</template>
        <template slot-scope="{ row, index }" slot="linkText">{{row.linkText}}</template>
        <template slot-scope="{ row, index }" slot="linkUrl">{{row.linkUrl}}</template>
        <template slot-scope="{ row, index }" slot="linkTextEn">{{row.linkTextEn}}</template>
        <template slot-scope="{ row, index }" slot="linkUrlEn">{{row.linkUrlEn}}</template>
        <template slot-scope="{ row, index }" slot="imgSet">
          <div style="display:flex;align-items:center;padding:10px 0;flex-wrap: wrap;">
             <img v-for="(item,index) in row.imgSet" :key="index" style="width:60px;height:60px;margin-bottom:5px;" :src="item.ImgUrl" @click="visible=true;imgurl=item.ImgUrl;" />
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="imgSetEn">
          <div style="display:flex;align-items:center;padding:10px 0;flex-wrap: wrap;">
            <img v-for="(item,index) in row.imgSetEn" :key="index" style="width:60px;height:60px;margin-bottom:5px;" :src="item.ImgUrl" @click="visible=true;imgurl=item.ImgUrl;" />
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
        <template slot-scope="{ row, index }" slot="action">
          <p style="color: #1890ff;cursor: pointer;" @click="setShow(row)">编辑</p>
          <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
            <p style="color: #f00;cursor: pointer;">删除</p>
          </Poptip>
        </template>
      </Table>
    </template>

    <iModal
      title="查看图片"
      v-model="visible"
      class-name="vertical-center-modal"
      width="600px"
      footer-hide
    >
      <div style="width:100%;height:100%;">
        <img style="width:100%;" :src="imgurl" />
      </div>
    </iModal>

    <div>
      <webMarathonEdit
      :show="editShow"
      :editInfo="editInfo"
      @finish="init()"
      @close="editShow=false;editInfo=null;"
    />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import webMarathonEdit from "./web-marathon-edit.vue";

export default {
  name: "common-ad-home",
  data() {
    return {
      list: [],
      columns1: [
        {
          title: "活动名称",
          slot: "name",
          key: "name",
          align: "center"
        },
        {
          title: "活动名称链接",
          slot: "nameUrl",
          key: "nameUrl",
          align: "center"
        },
        {
          title: "活动英文名称",
          slot: "nameEn",
          key: "nameEn",
          align: "center"
        },
        {
          title: "活动英文名称链接",
          slot: "nameEnUrl",
          key: "nameEnUrl",
          align: "center"
        },
        {
          title: "描述",
          slot: "remark",
          key: "remark",
          align: "center"
        },
        {
          title: "英文描述",
          slot: "remarkEn",
          key: "remarkEn",
          align: "center"
        },
        {
          title: "链接文字",
          slot: "linkText",
          key: "linkText",
          align: "center"
        },
        {
          title: "链接文字地址",
          slot: "linkUrl",
          key: "linkUrl",
          align: "center"
        },
        {
          title: "英文链接文字",
          slot: "linkTextEn",
          key: "linkTextEn",
          align: "center"
        },
        {
          title: "英文链接文字地址",
          slot: "linkUrlEn",
          key: "linkUrlEn",
          align: "center"
        },
        {
          title: "中文图片",
          slot: "imgSet",
          key: "imgSet",
          align: "center"
        },
        {
          title: "英文图片",
          slot: "imgSetEn",
          key: "imgSetEn",
          align: "center"
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      visible: false,
      imgurl: "",
      editShow: false,
      editInfo: null,
    }
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  methods: {
    ...mapActions({
      getMarathon: "hostCommonModule/getMarathon",
      delMarathon: "hostCommonModule/delMarathon"
    }),
    async init() {
      let list = await this.getMarathon();
      if (list && list.length > 0) {
        list.map(c => {
          c.imgSet = JSON.parse(c.imgSet);
          c.imgSetEn = JSON.parse(c.imgSetEn);
        })
      }
      this.list = list;
      console.log(123,this.list)
    },
    setShow(item) {
      this.editInfo = item;
      this.editShow = true;
    },
    async delItem(item) {
      let result = await this.delMarathon(item.id);
      if (result && result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
  },
  created() {
    this.init();
  },
  components: {
    webMarathonEdit
  }
}
</script>

<style lang="scss" scoped>
.host-ad {
  min-width: 600px;
  padding: 30px 30px 100px 30px;
}
</style>
<style lang="scss">
  .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal{
        top: 0;
    }
  }
</style>